import React from "react";
import "./Hero.css";
import Header from "../Header/Header";
import hero_image from "../../assets/hero_image.png";
import hero_back_image from "../../assets/hero_image_back.png";
import Heart from "../../assets/heart.png";
import Calories from "../../assets/calories.png";
import NumberCounter from "number-counter";

const Hero = () => {
  return (
    <div className="hero" id="hero-div">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />

        {/* the best ad */}
        <div className="the-best-ad">
          <div></div>
          <span>The best fitness gym in the town</span>
        </div>

        {/* Hero text */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Ideal Body</span>
          </div>
          <div>In here we will help you to shape and build you ideal body</div>
        </div>

        {/* figures */}
        <div className="figures">
          <div>
            <span>
              <NumberCounter
                start={50}
                end={100}
                delay={4}
                preFix="+"
              ></NumberCounter>
            </span>
            <span>Expert coach</span>
          </div>
          <div>
            <span>
              <NumberCounter
                start={80}
                end={130}
                delay={4}
                preFix="+"
              ></NumberCounter>
            </span>
            <span>Members joined</span>
          </div>
          <div>
            <span>
              <NumberCounter
                start={8}
                end={50}
                delay={4}
                preFix="+"
              ></NumberCounter>
            </span>
            <span>fitness programs</span>
          </div>
        </div>

        {/* hero buttons */}
        <div className="hero-buttons">
          <button className="btn">Get Started</button>
          <button className="btn">Learn More</button>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Join Now</button>
        <div className="heart-rate">
          <img src={Heart} alt="" />

          <span>Heart Rate</span>
          <span>115 bpm</span>
        </div>

        {/* hero images */}
        <img src={hero_image} alt="" />
        <img src={hero_back_image} alt="" />

        {/* calories */}
        <div className="calories">
          <img src={Calories} alt="" />
          <div>
            <span>Calorires Burned</span>
            <span>200 kcal</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
